'use strict';

const isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter(isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1
        ? 0
        : resolvedKeyframes.length - 1;
    return resolvedKeyframes[index]
        ;
}

exports.getFinalKeyframe = getFinalKeyframe;
//# sourceMappingURL=get-final-keyframe.cjs.map
